const homeRouteLocalStorageKey = 'lastHomeRoute';
const fallbackHomeRoute = 'customer-spaces';

export const storeHomeRoute = (path: string) => localStorage.setItem(homeRouteLocalStorageKey, path);

export const getStoredHomeRoute = () => localStorage.getItem(homeRouteLocalStorageKey) ?? fallbackHomeRoute;
